// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import { precisionKm } from 'config/constants'
import { roundToFixed } from 'helpers/reduxFormFunctions'
import { convertBetweenKMandMI } from 'helpers/unitConversion'

// if unitType is SI, then v is alreday in km.
// otherwise, convert v from miles to km.

const valueAsKm = (v, unitType) => (
  unitType === 'SI'
    ? roundToFixed(v, precisionKm)
    : convertBetweenKMandMI(v, 'SI')
)

export default valueAsKm
